export default __webpack_public_path__ + "static/media/one.0d87f0ab.jpeg";